module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('nprogress-container'), _vm._v(" "), (_vm.authenticated) ? _c('navbar', {
    attrs: {
      "show": true
    },
    on: {
      "logout": _vm.logout
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view', {
    staticClass: "approot"
  }), _vm._v(" "), (_vm.timesheetPage) ? _c('footer-bar', {
    attrs: {
      "show": false
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-671a67a0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./client/App.vue
// module id = 370
// module chunks = 66